import { render, staticRenderFns } from "./Techniques.vue?vue&type=template&id=51dcb72e&scoped=true"
import script from "./Techniques.vue?vue&type=script&lang=js"
export * from "./Techniques.vue?vue&type=script&lang=js"
import style0 from "./Techniques.vue?vue&type=style&index=0&id=51dcb72e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dcb72e",
  null
  
)

export default component.exports